import { useMemo } from 'react';
import { useConfigAtomValues, useDataAtomValues, useStateAtomValues } from '../state';
import { EServiceType } from '../constants';
export default function useComputedBuyNum() {
  var _useConfigAtomValues = useConfigAtomValues(),
    billId = _useConfigAtomValues.billId,
    _useConfigAtomValues$ = _useConfigAtomValues.buyNum,
    buyNum = _useConfigAtomValues$ === void 0 ? 1 : _useConfigAtomValues$;
  var _useDataAtomValues = useDataAtomValues(),
    productInfo = _useDataAtomValues.productInfo;
  var _useStateAtomValues = useStateAtomValues(),
    isBillIdByCreateSub = _useStateAtomValues.isBillIdByCreateSub;

  // 服务类商品下单并支付时,buyNum才生效，账单详情取下单时的快照，传入的buyNum无效
  var curBuyNum = useMemo(function () {
    // 从下单接口获取的billId，也就是当前处于结算页，保持传入的buyNum
    if (isBillIdByCreateSub) return buyNum;
    return !billId && (productInfo === null || productInfo === void 0 ? void 0 : productInfo.serviceType) === EServiceType.SERVICE ? buyNum : 1;
  }, [buyNum, billId, productInfo === null || productInfo === void 0 ? void 0 : productInfo.serviceType, isBillIdByCreateSub]);
  return curBuyNum;
}